<form [formGroup]="form" class="settings-form">
  <div class="section">
    <h3>Parâmetros de Financiamento - Empréstimo</h3>

    <div class="p-fluid grid gap-0">
      <!-- BOOLEANO -->
      <div class="col-12 flex gap-5 mb-4">
        <div class="flex gap-2">
          <p-checkbox
            formControlName="2"
            [binary]="true"
            (onBlur)="onToggleBlur()"
          ></p-checkbox>
          <label>Financiamento Empréstimo</label>
        </div>
      </div>

      <!-- NUMÉRICOS -->
      <div
        class="p-field flex flex-column gap-1 col-3"
        *ngFor="let field of numericFields; trackBy: trackById"
      >
        <label>{{ field.label }}</label>

        <input
          pInputText
          type="number"
          [step]="field.step || '1'"
          [formControlName]="field.id.toString()"
        />

        <small
          class="error"
          *ngIf="
            form.controls[field.id.toString()]?.touched &&
            form.controls[field.id.toString()]?.invalid
          "
        >
          Valor inválido
        </small>
      </div>

      <!-- SELECT -->
      <div
        class="p-field flex flex-column gap-1 col-3"
        *ngFor="let field of selectFields; trackBy: trackById"
      >
        <label>{{ field.label }}</label>

        <p-select
          [options]="aprovacaoOptions"
          optionLabel="label"
          optionValue="id"
          [formControlName]="field.id.toString()"
        ></p-select>
      </div>
    </div>
  </div>

  <div class="flex justify-content-end mt-4">
    <button
      pButton
      type="button"
      label="Guardar Alterações"
      icon="pi pi-save"
      (click)="save()"
      [disabled]="form.pristine"
    ></button>
  </div>
</form>


